import React from 'react'
import styles from './Disclaimer.module.css'

const Disclaimer = ({ onAccept, onDecline, showDeclineButton = true }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Disclaimer</h2>

        <div className={styles.content}>
          <p>
            This application is provided for informational and demonstration purposes only.
            It shall not be used for operational activities.
          </p>

          <p>
            All functionality is provided "as is", without any express or implied warranties,
            including but not limited to accuracy, completeness, or fitness for a particular purpose.
            By continuing to use this application, you acknowledge and agree that the developer
            assumes no responsibility or liability for any consequences arising from its use.
          </p>

          <h3 className={styles.subtitle}>Data and Privacy</h3>

          <p>
            This application does not collect or upload any user data or files to the server.
            All processing is performed entirely within your browser.
          </p>

          <p>
            If you have any questions, suggestions, or feedback, please contact us at{' '}
            <a href="mailto:aixmviewer@annea.sk">aixmviewer@annea.sk</a>.
          </p>
        </div>

        <div className={styles.buttons}>
          {showDeclineButton && (
            <button className={styles.declineButton} onClick={onDecline}>
              Decline
            </button>
          )}
          <button className={styles.acceptButton} onClick={onAccept}>
            {showDeclineButton ? 'Accept' : 'Close'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Disclaimer
